/* 平台下单 */
<template>
  <div id="orderFormByChannel2">

    <div v-if="printRow.startStationName" id="print" style="display: none;">
      <div style="padding-top: 92px;font-size:10px;display: inline-block;">
        <div style="margin-left:215px;height: 16px;">
          <span style="display: inline-block;width: 60px;vertical-align: top;">{{ printRow.startStationName }}</span>
          <span style="margin-left:10px;width: 60px;display: inline-block;vertical-align: top;">{{
            printRow.endStationName
          }}</span>
          <span style="margin-left:40px">{{ printRow.ticketFee }}</span>
        </div>
        <div style="margin:5px 0 0 80px">
          <span>{{ printRow.startLineTime }}</span>
          <span style="margin-left:12px">{{ printRow.licenseNo }}</span>
          <span style="margin-left:140px;;position: relative;top: 5px;">{{ printRow.ticketFee }}</span>
        </div>
        <div style="margin:25px 0 0 50px">
          <span>{{ $utils.timeFn(Date.parse(new Date()), 'YYYY.MM.DD') }}</span>
          <span style="margin-left:10px;display: inline-block;min-width:20px;">{{ printRow.ticketFee }}</span>
          <span style="margin-left:8px;display: inline-block;width:48px;vertical-align: top;">{{
            printRow.ticketSeller
          }}</span>
          <span style="margin-left:25px">{{ $utils.timeFn(printRow.schedulingTime, 'YYYY.MM.DD') }}</span>
          <span style="margin-left:35px">{{ printRow.startLineTime }}</span>
          <span style="margin-left:15px">{{ printRow.licenseNo }}</span>
          <span style="margin-left:15px">{{ printRow.seatNo }}</span>
        </div>
        <div style="margin:5px 0 0 233px">
          <span>{{ printRow.idCard.replace(/(.{10}).*(.{4})/, "$1****$2") }}</span> <span style="margin-left: 20px;">{{
            printRow.customerName }}</span>
        </div>
      </div>
    </div>
    <div class="orderFormByChannel2-header" @click="$router.back()"><img src="@/assets/img/back.jpg" /> 返回</div>

    <div class="ticketGetRow">
      <div>当前票号 : {{ ticketGetRow.ticketCurrentNo }}</div>
      <div>剩余票张数 : {{ ticketGetRow.remainingNum }}</div>
    </div>

    <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-position="left" style="margin-bottom:0">

      <div class="orderFormByChannel2-title">
        <div>窗口售票</div>
        <el-button type="primary" @click="refresh">刷新线路/班次</el-button>
      </div>

      <div style="padding: 20px 0; line-height: 18px">
        <p class="util-remark">
          * 无论是总公司，还是分公司，都只能选择自己机构下的线路进行下单
        </p>
      </div>

      <el-form-item label="选择线路" prop="lineId">
        <el-select v-model="form.lineId" @change="lineChange" :filter-method="textQueryLine"
          :placeholder="lines && lines.length > 0 ? '请选择线路 (支持 简拼/全拼/汉字/速记码 模糊搜索)' : '当前机构名称无可选线路'" filterable>
          <el-option v-for="(item) in lines" :key="item.id"
            :label="item.schedulingType == 3 ? item.startStationName + ' - ' + item.endStationName + ' ' + ' ' + '暂不支持选座下单' : item.startStationName + ' - ' + item.endStationName"
            :value="item.id" :disabled="item.schedulingType == 3">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择班次" prop="schedulingId" :rules="schedulings && schedulings.length < 1 && form.lineId
        ? [{ required: true, message: '请切换线路', trigger: ['blur', 'change'] }]
        : [{ required: true, message: '请选择班次', trigger: ['blur', 'change'] }]
        ">
        <el-select ref="selectSchedulingRef" v-model="form.schedulingId" @change="schedulingChange"
          @focus="schedulingFocus" :disabled="schedulings && schedulings.length < 1 && form.lineId ? true : false"
          :placeholder="schedulings && schedulings.length < 1 && form.lineId ? '该线路未排班，无可选班次' : '请选择班次'">
          <el-option v-for="(item, index) in schedulings" :key="index"
            :disabled="item.ticketNumType == 2 && !item.remainingTickets"
            :label="item.intercityName ? `【专线包车】 ${item.intercityName} / ${item.startTime}-${item.endTime} / ￥${item.serviceFee}` : `${$utils.timeFn(item.schedulingTime, 'YYYY/MM/DD')} ${item.startTime}-${item.endTime} ${item.ticketNumType == 1 ? '不限购' : '余' + item.remainingTickets} ￥${lineInfo.railType == 2 ? lineInfo.fee + '起' : lineInfo.fee} ${item.isCompensateTicket == 1 && item.status == 2 ? '(可补票)' : ''}`"
            :value="item.id">

            <template v-if="item.intercityName">
              <span style="float: left">
                {{ `【专线包车】 ${item.intercityName} / ${item.startTime}-${item.endTime} / ￥${item.serviceFee}` }}
              </span>
            </template>
            <template v-else>
              <span>
                {{
                  `${$utils.timeFn(item.schedulingTime, 'YYYY/MM/DD')} ${item.startTime}-${item.endTime}
                ${item.ticketNumType == 1 ? '不限购' : '余' + item.remainingTickets} ￥
                ${lineInfo.railType == 2 ? lineInfo.fee + '起' : lineInfo.fee}
                ${item.isCompensateTicket == 1 && item.status == 2 ? '(可补票)' : ''}`
                }}
              </span>
            </template>
          </el-option>
        </el-select>
        <span class="el-form-item-remark">
          可选择售票中班次，以及停售班次补票
        </span>
      </el-form-item>

      <el-form-item v-if="orderType == 2" label="用车时间" prop="rentTimeValueArr">
        <div class="time">
          <el-select v-model="rentTimeValueArr[0]" placeholder="选择日期">
            <el-option v-for="(item, index) in days" :key="item" :label="item" :value="index">
            </el-option>
          </el-select>

          <el-select v-model="rentTimeValueArr[1]" @change="rentTimeChange" placeholder="选择时间">
            <el-option v-for="(item, index) in hours" :key="item" :label="item + '时'" :value="index">
            </el-option>
          </el-select>

          <el-select v-model="rentTimeValueArr[2]" placeholder="选择时间">
            <el-option v-for="(item, index) in minutes" :key="item" :label="item + '分'" :value="index">
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="上车位置" prop="startAddress">
        <span style="font-size: 14px" v-if="lineInfo.lineType == 1 || lineInfo.lineType == 2">{{ startAddress }}</span>
        <el-button v-else :disabled="!form.lineId" @click="changeAddress(1)" type="text">
          {{ startAddress ? startAddress : "点击选择" }}
        </el-button>
      </el-form-item>

      <el-form-item label="下车位置" prop="endAddress">
        <span style="font-size: 14px" v-if="lineInfo.lineType == 1 || lineInfo.lineType == 4">{{ endAddress }}</span>
        <el-button v-else :disabled="!form.lineId" @click="changeAddress(2)" type="text">
          {{ endAddress ? endAddress : "点击选择" }}
        </el-button>
      </el-form-item>

      <template v-if="form.schedulingId">

        <template v-if="orderType == 1 && form.ticketRestrictions == 1">
          <el-form-item label="联系电话" prop="customerPhone" :rules="[
            { required: lineInfo.channelType != 2, message: '请输入乘客联系电话' },
            { pattern: /^1\d{10}$/, message: '请输入正确的联系电话' }]">
            <el-input :placeholder="`接收行程短信的手机号码${lineInfo.channelType == 2 ? ' (选填)' : ''}`"
              v-model="form.customerPhone" maxlength="11"></el-input>
          </el-form-item>

          <el-form-item label="购票数量" prop="passengerNum">
            <el-radio-group v-model="form.passengerNum" size="mini" @change="setPeople">
              <el-radio-button v-for=" item in 8" :label="item" :key="item"></el-radio-button>
            </el-radio-group>
          </el-form-item>
        </template>

        <template v-if="orderType == 1 && form.ticketRestrictions == 2">
          <el-form-item label="乘客身份信息" prop="customers" class="customersItem">
            <el-table class="customersTable" border empty-text="暂无数据" :data="form.customers">
              <el-table-column label="姓名" prop="name" v-slot="{ row }" width="100">
                <el-input v-model="row.name" maxlength="10" />
              </el-table-column>
              <el-table-column label="证件类型" prop="cardType" v-slot="{ row, $index }" width="130">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.cardType'">
                  <el-select v-model="row.cardType" placeholder="请选择证件类型" @change="row.idCard = ''">
                    <el-option v-for="(item, i) in $const.CARDTYPELIST" :key="i" :value="item.value"
                      :label="item.label"></el-option>
                  </el-select>
                </el-form-item>

              </el-table-column>
              <el-table-column label="证件号码" prop="idCard" v-slot="{ row, $index }">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.idCard'" :rules="[ {
                  pattern: $const.CARDRULES[row.cardType || 1].rules,
                  message: '请输入正确的证件号码',
                  trigger: ['blur', 'change'],
                  required: true
                }]">
                  <el-input v-model="row.idCard"
                    @input="row.idCard = row.idCard.toLocaleUpperCase(); $refs.form.validateField('customers')"
                    :maxlength="$const.CARDRULES[row.cardType || 1].maxLength" />
                </el-form-item>
              </el-table-column>
              <!-- <el-table-column label="身份证号码" prop="idCard" v-slot="{ row, $index }">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.idCard'" :rules="[{
                  pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                  message: '请输入正确的身份证号',
                  trigger: 'change'
                }]">
                  <el-input v-model="row.idCard"
                            @input="row.idCard = row.idCard.replace(/[^\dXx]/g, ''); $refs.form.validateField('customers')"
                            maxlength="18"/>
                </el-form-item>
              </el-table-column> -->
              <el-table-column label="手机号码" prop="phone" v-slot="{ row, $index }" width="130">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.phone'" :rules="[{
                  pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                  message: '请输入正确手机号',
                  trigger: 'change'
                }]">
                  <el-input v-model="row.phone"
                    @input="row.phone = row.phone.replace(/[^\d]/g, ''); $refs.form.validateField('customers')"
                    maxlength="11" :placeholder="lineInfo.channelType == 2 ? '选填' : ''"
                    :class="{ 'nocheck': lineInfo.channelType == 2 }" />
                </el-form-item>
              </el-table-column>
              <el-table-column label="联系人" v-slot="{ $index }" width="62">
                <el-radio v-model="isDefault" :label="$index" @input="isDefaultChange" />
              </el-table-column>
              <el-table-column v-if="lineInfo.channelType == 2" label="车票类型" v-slot="{ row }" width="135">
                <el-select v-model="row.ticketType" @change="calcFeeOfPeople" class="nocheck">
                  <el-option label="全票" :value="1" />
                  <el-option label="半价票" :value="2" />
                  <el-option label="免票(占座)" :value="3" />
                  <el-option label="免票(不占座)" :value="4" />
                </el-select>
              </el-table-column>
              <el-table-column label="操作" v-slot="{ $index }" width="90">
                <el-button type="text" @click="deleteCustomer($index)">删除</el-button>
                <el-button type="text" @click="readCard($index)">读卡</el-button>
              </el-table-column>
            </el-table>
            <el-button v-show="form.customers && form.customers.length < 8" class="add" @click="addCustomer">
              <i class="el-icon-circle-plus-outline"></i> 添加
            </el-button>
          </el-form-item>
        </template>

        <template v-if="orderType == 2">
          <template v-if="form.ticketRestrictions == 2">
            <el-form-item label="乘客姓名" prop="customerName">
              <el-input placeholder="请输入乘客姓名" maxlength="11" v-model="form.customerName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="customerIdCard">
              <el-input placeholder="与乘客身份证号一致" v-model="form.customerIdCard" maxlength="18"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="联系电话" prop="customerPhone">
            <el-input placeholder="联系手机号码" v-model="form.customerPhone" maxlength="11"></el-input>
          </el-form-item>

        </template>

        <div style="display: flex;align-items: center;justify-content: space-between;">
          <el-form-item label="保险张数" prop="insuranceNum" style="flex-grow: 1;margin-right: 50px;">
            <el-input v-model="form.insuranceNum"
              @input="form.insuranceNum = form.insuranceNum.replace(/^0|[^\d]/g, '')" maxlength="2">
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
          <el-form-item label="保险金额" prop="insuranceFee" style="flex-grow: 1;margin-left: 50px;">
            <el-input v-model="form.insuranceFee"
              @input="form.insuranceFee = form.insuranceFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{3,}/g, '999').replace(/(\d{1,3}\.?\d{0,1})?.*/g, '$1'); calcFeeOfPeople();">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>

        <el-form-item label="下单备注" prop="remark">
          <el-input v-model="form.remark" maxlength="30" style="width: 100%;"></el-input>
        </el-form-item>

        <el-form-item label="收款方式" prop="payChannel">
          <el-radio-group v-model="form.payChannel">
            <el-radio label="CHANNEL_COLLECTION_CODE">二维码收款</el-radio>
            <el-radio label="CHANNEL_CASH">现金</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="支付金额" prop="fee">
          <el-input :disabled="systemOrderFeeChange == 1 ? false : true" v-model="form.fee" maxlength="3"
            @input="form.fee = form.fee.replace(/[^\d]/g, '').replace(/^0[\d]/g, '0')" style="width: 180px;">
            <template slot="append">元</template>
          </el-input>
          <!-- <p class="util-remark">支付金额将从机构余额扣除</p> -->
        </el-form-item>
      </template>

    </el-form>

    <div class="orderFormByChannel2-footer">
      <el-button @click="$router.back()" :loading="loading">取消</el-button>
      <el-button type="primary" @click="saveClick" :loading="loading">确定</el-button>
    </div>

    <orderFormMap v-if="mapVisible" :visible.sync="mapVisible" :address.sync="mapAddress" :type="mapType"
      :fences="fences" :lineId="form.lineId" :lineType="lineInfo.lineType" :startRailNoSource="startRailNo"
      :endRailNoSource="endRailNo" @confirm="mapConfirm" @fee="fee" @startRailNo="start" @endRailNo="end" />

    <!-- 票据选择 -->
    <el-dialog :visible.sync="dialogVisible" title="票据选择" width="600px" :show-close="false" append-to-body
      :close-on-click-modal='false' :close-on-press-escape='false'>
      <custom-table ref="customTable" emptyText="请先领取票据后下单" :customOptions="customOptions" :columns="columns"
        :has-organization="false" :paging="false" @listBack="ticketListBack" maxHeight="300">
        <template slot="table-operation">
          <el-table-column label="操作" width="100" fixed="right" v-slot="{ row }">
            <el-button type="text" size="small" @click="selectPush(row)">选择</el-button>
          </el-table-column>
        </template>
        <template slot-scope="{item, row}">
          <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </custom-table>
      <el-button @click="$router.back()" type="primary" style="width:100%;margin: 20px 0;">退出</el-button>
    </el-dialog>

    <!-- 票据打印 -->
    <el-dialog :visible.sync="dialogVisible2" title="票据打印" width="1000px" append-to-body :close-on-click-modal='false'
      :close-on-press-escape='false' @close="printListClose" style="margin-top: 140px;">
      <el-table :data="printList" v-loading="printListLoading" empty-text="暂无数据" border style="margin-bottom: 20px;">
        <el-table-column label="票号" prop="ticketNo" width="100"></el-table-column>
        <el-table-column label="线路" prop="startStationName" v-slot="{ row }">
          {{ row.startStationName + ' - ' + row.endStationName }}
        </el-table-column>
        <el-table-column label="票价" prop="ticketFee" width="60"></el-table-column>
        <el-table-column label="乘车日期" prop="schedulingTime" width="100" v-slot="{ row }">
          {{ row.schedulingTime | filterTime('YYYY-MM-DD') }}
        </el-table-column>
        <el-table-column label="开车时间" prop="startLineTime" width="70"></el-table-column>
        <el-table-column label="车次" prop="licenseNo" width="100"></el-table-column>
        <el-table-column label="乘客" prop="customerName" width="70"></el-table-column>
        <el-table-column label="座号" prop="seatNo" width="50"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100" v-slot="{ row }">
          <el-button type="text" size="small" @click="print(row)">打印</el-button>
          <el-button type="text" size="small" @click="cancellation(row)">作废</el-button>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 票据选择 -->
    <el-dialog :visible.sync="billDialogVisible" title="票据选择" width="600px" :show-close="false" append-to-body
      :close-on-click-modal='false' :close-on-press-escape='false'>
      <div style="width: 100%">
        <el-button :loading="loading" style="margin-bottom: 20px;" icon="el-icon-refresh"
          @click="getBillListFn"></el-button>

        <el-table v-loading="loading" style="width: 100%;margin-bottom: 20px;" :data="billList" emptyText="无可票据选择"
          border>
          <el-table-column label="当前票号" prop="ticketCurrentNo"></el-table-column>
          <el-table-column label="剩余张数" prop="remainingNum"></el-table-column>
          <el-table-column label="入库时间" prop="created" v-slot="{ row }">
            {{ row.created | filterTime('YYYY-MM-DD') }}
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100" v-slot="{ row, $index }">
            <el-checkbox @change="checkboxChangeFn(row, $index)" v-model="row.checkboxStatus"></el-checkbox>
          </el-table-column>
        </el-table>

      </div>
      <div style="display: flex;justify-content: flex-end">
        <el-button @click="billDialogVisible = false">取消</el-button>
        <el-button @click="billClickFn" :loading="billLoading" type="primary">确定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import orderFormMap from "./orderFormMap";

export default {
  components: { orderFormMap },
  name: "orderFormByChannel2",
  props: {
    copyPhone: {
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      ws: null,

      dialogVisible: true,
      customOptions: {
        url: '/api/v1/manage/order/manage/ticket',
        params: {
          page: 1, // 页数
          size: 999, // 每页条数 
        }
      },
      columns: [
        { prop: 'ticketCurrentNo', label: '当前票号' },
        { prop: 'remainingNum', label: '剩余张数', width: 100 },
        { prop: 'created', label: '入库时间', width: 150 },
      ],
      ticketGetRow: {},

      getPrintListTimer: null,
      dialogVisible2: false,
      printListLoading: false,
      printList: [],
      printRow: {},

      mapVisible: false,
      mapType: 1,
      mapAddress: {},
      customersState: false,
      lineInfo: {},
      // 表单
      form: {
        address: [{ type: 1 }, { type: 2 }],
        customers: [],
        ticketRestrictions: 1, // 默认快捷，购票限制：1-快捷购票，2-实名购票
        fee: null,
        schedulingId: null,
        lineId: null,
        customerName: null,
        customerIdCard: null,
        customerPhone: null,
        passengerNum: null,
        startAddress: null,
        endAddress: null,
        remark: null,
        insuranceNum: 0,
        insuranceFee: 0,
        payChannel: null,
      },
      // 校验规则
      rules: {
        customerPhone: [
          { required: true, message: "请输入乘客联系电话" },
          { pattern: /^1\d{10}$/, message: "请输入正确的联系电话" },
        ],
        customerName: [{ required: true, message: '请输入乘客姓名', trigger: 'change' }],
        customerIdCard: [
          { required: true, message: '请输入身份证号', trigger: 'change' },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '请输入正确的身份证号'
          }
        ],
        passengerNum: [{ required: true, message: "请选择购票数量" }],
        payChannel: [{ required: true, message: "请选择收款方式" }],
        customers: [{
          required: true,
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            if (!value || value.length == 0) {
              callback(new Error("请添加乘客信息"));
            } else {
              this.form.customers.find(item => {
                if (!item.name || !item.idCard || (!item.phone && this.lineInfo.channelType != 2)) {
                  callback(new Error("请检查乘客身份信息否输入正确！"));
                  return true
                }
              })
              callback();
            }
          }
        }],
        startAddress: [
          {
            required: true,
            message: "请选择上车位置",
            trigger: ["blur", "change"],
          },
        ],
        endAddress: [
          {
            required: true,
            message: "请选择下车位置",
            trigger: ["blur", "change"],
          },
        ],
        lineId: [{ required: true, message: "请选择线路" }],
        fee: [{ required: true, message: "请输入支付金额", trigger: "blur" }],
        rentTimeValueArr: [{
          validator: (rule, value, callback) => {
            if (!(this.rentTimeValueArr[0] != null && this.rentTimeValueArr[1] != null && this.rentTimeValueArr[2] != null)) {
              callback(new Error("请选择完整的用车时间"));
              return;
            }
            let date = new Date(this.days[this.rentTimeValueArr[0]]);
            date.setHours(this.hours[Number(this.rentTimeValueArr[1])])
            date.setMinutes(this.minutes[Number(this.rentTimeValueArr[2])])
            date.setSeconds(0)
            date.setMilliseconds(0)
            if (date.getTime() < Date.now()) {
              callback(new Error("请选择大于当前时间的选值"));
            } else {
              this.form.serviceTime = date.getTime();
              callback();
            }
          }, required: true, trigger: 'change'
        }]
      },
      isDefault: 0,
      loading: false,
      // 菜单信息列表
      list: [],
      // 线路详情
      fences: [],
      lines: [],
      linesSource: [],
      schedulings: [],
      startRailNo: null,
      endRailNo: null,

      orderType: 1,
      days: [],
      hours: [],
      minutes: ['00', '10', '20', '30', '40', '50'],
      rentTimeValueArr: [null, null, null],

      readIndex: null,
      readSwitch: false,
      myWorker: null,
      message: null,

      systemOrderFeeChange: "",

      billList: [],
      billForm: {},
      billLoading: false,
      printRowId: '',
      billDialogVisible: false,

    };
  },
  computed: {
    /* 是否显示地图上围栏相关的操作按钮 */
    startAddress() {
      let item = this.form.address.find((item) => item.type == 1);
      let name = item.name;
      this.$set(this.form, "startAddress", name);
      return name;
    },
    endAddress() {
      let item = this.form.address.find((item) => item.type == 2);
      let name = item.name;
      this.$set(this.form, "endAddress", name);
      return name;
    }
  },
  watch: {
    form(newval, oldval) {
      if (newval != oldval) {
        return null;
      }
    },
    "form.fee"(val) {
      if (typeof val == "undefined") {
        this.form.fee = null;
      }
    },
  },
  created() {
    this.getTicketRestrictions();
    this.getLines();
    this.connectionCardReader();
    if (this.copyPhone) {
      this.form.customerPhone = this.copyPhone
    }
  },
  mounted() {
    // this.myWorker = new Worker('/worker.js');
    // this.myWorker.onmessage = (e) => {
    //   console.log("主线程接收参数:", e);
    // };
  },
  methods: {
    async billClickFn() {
      const status = this.billList.some((item) => item.checkboxStatus)
      if (!status) {
        this.$message.warning('请选择作废的票号')
        return
      }
      this.billLoading = true
      const url = '/api/v1/manage/order/ticket/cancellation'
      const { code } = await this.$axios.post(url, this.billForm)
      this.billLoading = false
      if (code === 1) {
        this.billDialogVisible = false
        this.billForm = {}
        this.$message.success("操作成功");
        this.getTicketDetial()
        this.getPrintList(this.printRowId)
      }

    },
    checkboxChangeFn(row, num) {
      this.billForm.ticketCurrentNo = row.ticketCurrentNo
      this.billForm.ticketReceiveId = row.id
      this.billList = this.billList.map((item, index) => {
        return {
          ...item,
          checkboxStatus: index === num
        }
      })
    },
    cancellation(row) {
      this.billForm = {
        orderId: row.orderId,
        ticketNo: row.ticketNo
      }
      this.billDialogVisible = true
      this.getBillListFn()
    },
    async getBillListFn() {
      this.loading = true
      const { code, data } = await this.$axios.get('/api/v1/manage/order/manage/ticket', {
        page: 1,
        size: 999,
        appKey: this.mixinUserInfo?.appKey,
      })
      this.loading = false
      if (code === 1 && data) {
        this.billList = data.map((item) => ({ ...item, checkboxStatus: false }))
      }
    },
    // /* webworker */
    // postmessage(e) {
    //   console.log("主线程发送参数:", e);
    //   this.myWorker.postMessage(e);
    // },
    /* 连接读卡器 */
    connectionCardReader() {
      const webUrl = 'ws://' + '127.0.0.1:30004' + '/ws'
      this.ws = new WebSocket(webUrl)
      this.ws.onopen = () => {
        // console.log('读卡器驱动websocket连接成功');
      }
      this.ws.onclose = () => {
        // console.log('读卡器驱动websocket已断开')
      }
      this.ws.onmessage = (messageEvent) => {
        if (!this.readSwitch) return;
        const jsonobject = JSON.parse(messageEvent.data)
        if (jsonobject.Ret == 0) {
          if (jsonobject.Cmd == 10001) {
            const szparam = JSON.parse(window.atob(jsonobject.UserParam))

            let hex2a = (hex) => {
              let str_list = ''
              for (let i = 0; i < hex.length && hex.substr(i, 2) !== '00'; i += 2) {
                const a = hex.charCodeAt(i)
                const b = hex.charCodeAt(i + 1)
                const c = b * 256 + a
                str_list += String.fromCharCode(c)
              }
              return str_list.toString()
            }

            let parseDateString = (str, deco, zero) => {
              let year = str.substr(0, 4)
              let month = str.substr(4, 2)
              let date = str.substr(6)
              if (zero) {
                month = month.substr(0, 1) === "0" ? month.substr(1) : month
                date = date.substr(0, 1) === "0" ? date.substr(1) : date
              }
              return `${year}${deco}${month}${deco}${date}`
            }
            let birthday = hex2a(window.atob(szparam.CardInfo.Birthday))
            let birthArr = parseDateString(birthday, ".", true).split(".")

            let info = {
              name: hex2a(window.atob(szparam.CardInfo.Name)).trim(),
              number: hex2a(window.atob(szparam.CardInfo.No)),
              // sex: hex2a(window.atob(szparam.CardInfo.Sex)),
              // nation: hex2a(window.atob(szparam.CardInfo.Nation)),
              // birthday: hex2a(window.atob(szparam.CardInfo.Birthday)),
              // year: birthday[0],
              // month: birthArr[1],
              // date: birthArr[2],
              // address: hex2a(window.atob(szparam.CardInfo.Address)),

              // signedDepartment: hex2a(window.atob(szparam.CardInfo.SignedDepartment)).trim(),
              // validityPeriodBegin: hex2a(window.atob(szparam.CardInfo.ValidityPeriodBegin)),
              // validityPeriodEnd: hex2a(window.atob(szparam.CardInfo.ValidityPeriodEnd))
            }
            this.$set(this.form.customers[this.readIndex], 'name', info.name)
            this.$set(this.form.customers[this.readIndex], 'idCard', info.number)
            this.$set(this.form.customers[this.readIndex], 'cardType', 1)
            this.readSwitch = false;
          } else if (jsonobject.Cmd == 1000) {
            let szparam = JSON.parse(window.atob(jsonobject.UserParam));
            if (szparam.State == 0) {
              this.$message.info('读卡器已被拔出');
              this.readIndex = null;
              this.readSwitch = false;
            }
          }
        } else {
          this.$message.info('读卡失败，原因：' + jsonobject.ErrInfo);
        }
      }
    },
    /* 手动读卡 */
    cardReadInfo() {
      const szJson = '{"Cmd":10000,"Head":"YZWL","IPFlag":"MGEyZmU1NmY5ODZlZGMyNg==","UserParam":"eyJBcHBLZXkiOiI5OWZmYjJmOThhMjkwNzExMDdjN2EwOWFkMmM2ZDA5NiIsIkRlY29kZVBob3RvIjp0cnVlLCJGYWNlQ29tcGFyZSI6ZmFsc2UsIlBob3RvRm9ybWF0IjoxLCJTZXJ2ZXJJUCI6ImlkLnl6ZnV0dXJlLmNuIiwiU2VydmVyUG9ydCI6ODg0OH0NCg==","Version":"V1.0.0"}\n'
      this.ws.send(szJson)
    },

    /* 票据列表 */
    ticketListBack(data) {
      // if (data.length == 0) {
      //   this.$message.info('请先领取票据后下单')
      // }
    },

    /* 选择票据 */
    selectPush(row) {
      this.ticketGetRow = row;
      this.dialogVisible = false;
    },

    /* 更新选择的票据 */
    async getTicketDetial() {
      let url = " /api/v1/manage/ticket/receive/" + this.ticketGetRow.id;
      let data = await this.$axios.get(url);
      if (data?.code == 1 && data.data) {
        this.ticketGetRow = data.data;
        if (data.data.remainingNum == 0) {
          this.dialogVisible = true;
          this.$nextTick(() => {
            this.$refs.customTable.listFn();
          })
        }
      }
    },

    /* 获取刚下单的票据打印列表 */
    getPrintList(id) {
      this.dialogVisible2 = true;
      this.printListLoading = true;
      this.printRowId = id

      this.getPrintListTimer = setInterval(async () => {
        let url = "/api/v1/manage/order/ticket/print/" + id;
        let data = await this.$axios.get(url);
        if (data?.code == 1 && data.data && data.data.length > 0) {
          this.printList = data.data;
          this.printListLoading = false;
          clearInterval(this.getPrintListTimer);
        }
      }, 1000);
    },

    printListClose() {
      console.log(this.getPrintListTimer);
      if (this.getPrintListTimer) clearInterval(this.getPrintListTimer)
      console.log(this.getPrintListTimer);
    },


    changeAddress(mapType) {
      if (
        this.lineInfo.lineType == 1 ||
        (this.lineInfo.lineType == 2 && mapType == 1) ||
        (this.lineInfo.lineType == 4 && mapType == 2)
      ) {
        return;
      }
      if (
        mapType == 2 &&
        !this.startRailNo &&
        this.lineInfo.lineType != 1 &&
        this.lineInfo.lineType != 2
      ) {
        this.$message.info("请先选择上车点");
        return;
      }
      this.mapType = mapType;
      this.mapVisible = true;
      this.mapAddress = this.form.address
        ? this.form.address.find((item) => item.type == mapType)
        : {};
    },

    refresh() {
      this.getLines();
      this.$refs.form.resetFields();
      this.orderType = 1;
      this.form.customers = [];
      this.form.address = [{ type: 1 }, { type: 2 }];
    },

    /* 获取基础配置详情 */
    async getTicketRestrictions() {
      let url = "/api/v1/manage/order/manage/querySystemsConfig";
      let data = await this.$axios.get(url);
      if (data?.code == 1 && data.data) {
        this.systemOrderFeeChange = data.data.systemOrderFeeChange;
      }
    },

    customersConfirm(customers) {
      this.$set(this.form, "customers", customers);
      this.$refs.form.validateField("customers");
    },
    start(e) {
      this.startRailNo = e;
    },
    end(e) {
      this.endRailNo = e;
    },
    fee(e) {
      this.lineInfo.fee = e;
    },
    async mapConfirm(e) {
      let address = this.form.address;
      address = address.map((item) => {
        if (item.type == this.mapType) {
          item = e
        }
        return item;
      });
      this.form.address = address;
      this.form[this.mapType == 1 ? "startAddress" : "endAddress"] = e;
      this.$refs.form.validateField(this.mapType == 1 ? "startAddress" : "endAddress");
      if (this.endRailNo) {
        /* 获取价格 */
        let getPrice = async (lineId, startRailNo, endRailNo) => {
          let url = "/api/v1/manage/order/manage/queryStartRailFee";
          let params = { type: 2, lineId, startRailNo, endRailNo, appKey: this.mixinUserInfo?.appKey };
          let data = await this.$axios.get(url, params);

          if (data && data.code == 1) {
            this.lineInfo.fee = data.data.fee;
          }
        }
        await getPrice(this.form.lineId, this.startRailNo, this.endRailNo);
      }

      this.setPeople();
    },

    /* 查询线路 */
    textQueryLine(value) {
      this.lines = this.linesSource.filter(item => {
        let matchName = item.startStationName.includes(value) || item.endStationName.includes(value);
        let matchCode = (item.startStationCode ? item.startStationCode.includes(value) : false) || (item.endStationCode ? item.endStationCode.includes(value) : false);
        let matchPinyinFn = (string => {
          let match = true;
          let matchIndexArr = [];
          value.split('').map(word => {
            let matchArr = [];
            string.split('').map((item, index) => {
              if (item == word) {
                matchArr.push(index)
              }
            });
            let matchDiff = matchArr.filter(item => !matchIndexArr.includes(item));
            if (matchDiff.length > 0) {
              matchIndexArr.push(matchDiff[0])
            } else {
              match = false;
            }
          })
          return match;
        })
        let matchPinyin = matchPinyinFn(item.startStationPy) || matchPinyinFn(item.endStationPy);

        return matchName || matchCode || matchPinyin;
      })
    },

    /* 线路变更 */
    async lineChange(val) {
      this.lines = this.linesSource;
      this.startRailNo = null;
      this.endRailNo = null;
      this.$set(this.form, "schedulingId", "");
      this.schedulings = [];
      if (val) {
        await this.getScheduling(val);
        let item = this.lines.find((item) => item.id == val);
        this.form.ticketRestrictions = item.ticketRestrictions;

        if (item) {
          this.lineInfo = item;
        } else {
          this.lineInfo = {};
        }
        this.getFence(val);
      }
      this.$nextTick(() => {
        this.$refs.form.validate(() => {
        });

        this.$refs.selectSchedulingRef.visible = true
      })
    },

    async getFence(lineId) {
      let url = "/api/v1/manage/order/manage/fence";
      let params = { lineId, appKey: this.mixinUserInfo?.appKey };
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        let lineType = this.lineInfo.lineType;
        let address = [{ type: 1 }, { type: 2 }];
        switch (lineType) {
          // 站点-站点
          case 1:
            this.startRailNo = data.data[0].stationRail[0].railNo;
            this.endRailNo = data.data[1].stationRail[0].railNo;
            address = data.data.map((dataItem) => {
              dataItem = {
                type: dataItem.stationRail[0].type,
                city: dataItem.stationRail[0].city,
                longitude: dataItem.stationRail[0].longitude,
                latitude: dataItem.stationRail[0].latitude,
                name: dataItem.stationRail[0].stationName,
                address: dataItem.stationRail[0].stationAddress,
              };
              return dataItem;
            });
            break;
          // 站点-送人
          case 2:
            let dataItem2 = data.data.find((item) => item.type == 1);
            address = address.map((item) => {
              if (item.type == 1) {
                item = {
                  type: item.type,
                  city: dataItem2.stationRail[0].city,
                  longitude: dataItem2.stationRail[0].longitude,
                  latitude: dataItem2.stationRail[0].latitude,
                  name: dataItem2.stationRail[0].stationName,
                  address: dataItem2.stationRail[0].stationAddress,
                };
              }
              return item;
            });
            break;
          // 接人-站点
          case 4:
            let dataItem4 = data.data.find((item) => item.type == 2);
            address = address.map((item) => {
              if (item.type == 2) {
                item = {
                  type: item.type,
                  city: dataItem4.stationRail[0].city,
                  longitude: dataItem4.stationRail[0].longitude,
                  latitude: dataItem4.stationRail[0].latitude,
                  name: dataItem4.stationRail[0].stationName,
                  address: dataItem4.stationRail[0].stationAddress,
                };
              }
              return item;
            });
            break;
        }
        if (this.lineInfo.channelType == 2) {
          this.startRailNo = data.data[0].stationRail[0].railNo;
          this.endRailNo = data.data[1].stationRail.slice(-1)[0].railNo;
          this.form.startAddress = data.data[0].stationRail[0];
          this.form.endAddress = data.data[1].stationRail.slice(-1)[0];
          address = data.data.map((dataItem, index) => {
            if (index == 0) {
              dataItem = {
                type: dataItem.stationRail[0].type,
                city: dataItem.stationRail[0].city,
                longitude: dataItem.stationRail[0].longitude,
                latitude: dataItem.stationRail[0].latitude,
                name: dataItem.stationRail[0].stationName,
                address: dataItem.stationRail[0].stationAddress
              };
            } else {
              dataItem = {
                type: dataItem.stationRail.slice(-1)[0].type,
                city: dataItem.stationRail.slice(-1)[0].city,
                longitude: dataItem.stationRail.slice(-1)[0].longitude,
                latitude: dataItem.stationRail.slice(-1)[0].latitude,
                name: dataItem.stationRail.slice(-1)[0].stationName,
                address: dataItem.stationRail.slice(-1)[0].stationAddress,
              };
            }
            return dataItem;
          });
          /* 获取价格 */
          let getPrice = async (lineId, startRailNo, endRailNo) => {
            let url = "/api/v1/manage/order/manage/queryStartRailFee";
            let params = { type: 2, lineId, startRailNo, endRailNo, appKey: this.mixinUserInfo?.appKey };
            let data = await this.$axios.get(url, params);
            if (data && data.code == 1) {
              this.lineInfo.fee = data.data.fee;
            }
          }
          await getPrice(lineId, this.startRailNo, this.endRailNo);
        }
        this.form.address = address;
        this.fences = data.data || [];
      }
      this.$nextTick(() => {
        this.$refs.form.validate(() => {
        });
      })
    },

    schedulingFocus() {
      if (!this.form.lineId) {
        this.$message.warning("请先选择线路");
      }
    },

    /* 线路详情 */
    async getLines() {
      let url = "/api/v1/manage/order/manage/line";
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.lines = data.data || [];
        this.linesSource = data.data || []
      }
    },

    /* 班次列表 */
    async getScheduling(lineId) {
      let url = "/api/v1/manage/order/manage/scheduling/new";
      let params = { lineId, appKey: this.mixinUserInfo?.appKey };
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        this.schedulings = data.data.intercityVos.concat(data.data.schedulingVos);
        
      }
    },

    /* 班次变更 */
    schedulingChange(val) {
      let item = this.schedulings.find((item) => item.id == val);
      if (item) {
        this.$set(this.form, "schedulingId", item.id);
        this.$set(this.form, "endTime", item.endTime);
        this.$set(this.form, "startTime", item.startTime);

        if (item.schedulingTime) {
          if (this.orderType == 2) {
            this.$set(this.form, "fee", null);
          }
          this.orderType = 1; // 有schedulingTime就是1
          this.$set(this.form, "schedulingTime", item.schedulingTime);
        } else {
          this.orderType = 2;
          this.$set(this.form, "passengerNum", 1);
          this.$set(this.form, "serviceFee", item.serviceFee);
          this.$set(this.form, "fee", item.serviceFee);
          this.$set(this.form, "lineIntercityId", item.id);
          this.$set(this.form, "intercityName", item.intercityName);
          this.$set(this.form, "vehicleSeat", item.vehicleSeat);
          this.$refs.form.clearValidate("passengerNum");
          this.getRentTime(item);
        }
        this.$nextTick(() => {
          this.$refs.form.validate(() => {
          });
          !this.form.customers.length && this.addCustomer()
        })
      }
    },

    /* 获取用车日期 初始化用车时间 */
    async getRentTime(item) {
      let url = "/api/v1/manage/order/manage/intercity/time/" + this.form.lineId;
      let data = await this.$axios.get(url, { appKey: this.mixinUserInfo?.appKey });
      if (data && data.code == 1) {
        let days = [];
        data.data.map(time => {
          time = new Date(time * 1000).toLocaleDateString();
          days.push(time)
        })
        this.days = days;
      }

      let supplementZero = (val) => val < 10 ? ('0' + val) : String(val)
      let hours = [];
      for (let i = Number(item.startTime.slice(0, 2)); i <= Number(item.endTime.slice(0, 2)); i++) {
        hours.push(supplementZero(Number(i)))
      }
      this.hours = hours;
    },

    /* 用车时间Change */
    rentTimeChange() {
      if (this.rentTimeValueArr[1] == this.hours.length - 1) {
        this.rentTimeValueArr[2] = 0
        this.minutes = ['00']
      } else {
        this.minutes = ['00', '10', '20', '30', '40', '50']
      }
    },

    /* 计算乘客列表费用 */
    calcFeeOfPeople() {

      if (this.form.ticketRestrictions == 1) {
        this.form.fee = Number(((this.lineInfo.fee * 100 * this.form.passengerNum) / 100).toFixed(2)) + Number(this.form.insuranceFee || 0);
      } else {
        let fee = 0;
        this.form.customers.map(item => {
          fee += [this.lineInfo.fee, Math.ceil(this.lineInfo.fee * 100 / 2) / 100, 0, 0][item.ticketType - 1]
        })
        this.form.fee = fee + Number(this.form.insuranceFee || 0);
      }

    },

    /* 修改人数 */
    setPeople() {
      if (!this.form.passengerNum) return;
      if (this.lineInfo.fee || this.form.serviceFee) {
        console.log(444);
        if (this.orderType == 1) {
          this.calcFeeOfPeople();
        } else {
          this.form.fee = this.form.serviceFee * this.form.passengerNum;
        }
        this.$refs.form.validateField("fee");
      }
    },

    /* 添加实名乘客 */
    addCustomer() {
      this.form.customers.push({ ticketType: 1, cardType: 1 });

      if (this.form.customers.length == 1) {
        this.form.customers[0].isDefault = 1;
      } else {
        this.form.customers[this.form.customers.length - 1].isDefault = 2;
      }
      this.calcFeeOfPeople();
      this.form.passengerNum = this.form.customers.length;
      this.$refs.form.validateField("fee");
    },

    /* 删除实名乘客 */
    deleteCustomer(index) {
      this.form.customers.splice(index, 1)
      this.calcFeeOfPeople();
      this.form.passengerNum = this.form.customers.length;
      this.$refs.form.validateField('customers');
      if (index == this.isDefault) {
        this.isDefault = 0;
        if (this.form.customers.length > 0) {
          this.isDefaultChange(0)
        }
      } else if (index < this.isDefault) {
        this.isDefault -= 1;
      }
    },

    /* 修改默认联系人 */
    isDefaultChange(index) {
      this.form.customers.map((item, i) => {
        if (index == i) {
          item.isDefault = 1
        } else {
          item.isDefault = 2
        }
      })
    },

    /* 读卡 */
    readCard(index) {
      this.readIndex = index;
      this.readSwitch = true;
      this.cardReadInfo();
    },

    /* 实名校验 */
    async realName() {
      let params = {
        name: this.form.customerName,
        idCard: this.form.customerIdCard,
        lineId: this.form.lineId,
        appKey: this.mixinUserInfo?.appKey,
      };
      let data = await this.$axios.post("/api/v1/manage/order/manage/customer/realName", params);
      if (data && data.code === 1) {
        return true
      } else {
        return false
      }
    },

    /* 点击保存 */
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.insuranceFee > 0 && this.form.insuranceNum == 0) {
            this.$message.info('保险张数与保险金额不匹配')
            return;
          }
          if (this.form.ticketRestrictions == 1) {
            if (this.form.insuranceNum > this.form.passengerNum) {
              this.$message.info('保险张数不能大于乘客人数')
              return;
            }
          } else {
            if (this.form.customers && this.form.customers.length) {
              if (this.form.insuranceNum > this.form.customers.length) {
                this.$message.info('保险张数不能大于乘客人数')
                return;
              }
            }
          }


          if (this.form.ticketRestrictions == 1) {
            if (this.form.passengerNum > this.ticketGetRow.remainingNum) {
              this.$message.info('购票乘客数不能大于剩余票张数')
              return;
            }
            this.form.ticketNum = this.form.passengerNum;
          } else {
            let ticketNum = this.form.customers.reduce((total, item) => {
              if ([1, 2].includes(item.ticketType)) {
                return total += 1;
              } else {
                return total;
              }
            }, 0)
            if (ticketNum > this.ticketGetRow.remainingNum) {
              this.$message.info('购票乘客数不能大于剩余票张数')
              return;
            }
            this.form.ticketNum = ticketNum;
          }

          // let bl = false;
          // let repeatIdCard = [];
          // this.form.customers.map(item => {
          //   if (repeatIdCard.includes(item.idCard)) {
          //     bl = true;
          //   } else {
          //     repeatIdCard.push(item.idCard)
          //   }
          // })
          // if (bl) {
          //   this.$message.info('乘客身份证不可重复')
          //   return;
          // }

          if (this.orderType == 2 && this.form.ticketRestrictions != 1) {
            let bl = await this.realName();
            if (!bl) {
              return;
            }
          }

          let params = this.$utils.deepCopyFn(this.form);

          params.customers = params.customers ? JSON.stringify(params.customers) : [];
          params.address = params.address ? JSON.stringify(params.address) : [];
          params.orderFee = this.form.fee;
          params.railFee = this.lineInfo.fee;
          params.endRailNo = this.endRailNo;
          params.startRailNo = this.startRailNo;
          params.ticketReceiveId = this.ticketGetRow.id;
          params.ticketCurrentNo = this.ticketGetRow.ticketCurrentNo;
          delete params.startAddress;
          delete params.endAddress;
          this.postFn(params);
        }
      });
    },

    /* 接口请求-提交 */
    async postFn(params) {
      this.loading = true;
      let url = this.orderType == 1 ? "/api/v1/manage/order/manage" : "/api/v1/manage/order/manage/intercity";
      let data = await this.$axios.post(url, params);
      this.loading = false;

      if (data && data.code == 1) {
        await this.getTicketDetial();
        if (params.ticketNum > 0) {
          this.getPrintList(data.data);
        }

        this.form = {
          address: [{ type: 1 }, { type: 2 }],
          customers: [],
          ticketRestrictions: 1,
          fee: null,
          schedulingId: null,
          lineId: null,
          customerName: null,
          customerIdCard: null,
          customerPhone: null,
          passengerNum: null,
          startAddress: null,
          endAddress: null,
          remark: null,
        };
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['lineId', 'schedulingId']);
        })
        this.getTicketRestrictions();
        this.getLines();
        this.schedulings = [];
        this.lineInfo = {};
        this.orderType = 1;
        this.isDefault = 0;
        this.rentTimeValueArr = [null, null, null]
        if (this.copyPhone) {
          this.$emit("callCatPaOSuccess");
        }
      } else if (data.code == 50048) {
        this.refresh();
      }
    },

    /* 打印发票 */
    print(row) {

      // html2canvas(document.querySelector('#print')).then(canvas => {
      //   const imgUrl = canvas.toDataURL('image/jpeg')
      //   const image = document.createElement('img')
      //   image.src = imgUrl
      //   // 将生成的图片放到 类名为 content 的元素中
      //   document.querySelector('#print').appendChild(image)
      //   const a = document.createElement('a')
      //   a.href = imgUrl
      //   // a.download 后面的内容为自定义图片的名称
      //   a.download = 'study_download'
      //   a.click()
      // })

      // return;

      this.printRow = row;
      console.log(row, 11111);

      this.$nextTick(() => {
        const printContentHtml = document.getElementById("print").innerHTML;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.contentDocument.write(printContentHtml);
        iframe.contentDocument.close();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 2000);
      })
    },
  }
};
</script>

<style lang="less">
#orderFormByChannel2 {
  height: calc(100% - 48px);
  padding-bottom: 50px;
  box-sizing: border-box;
  color: black;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-y: scroll;

  .ticketGetRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 17px;
    font-weight: bold;
  }

  .nocheck input {
    border: 1px #dcdfe6 solid;
  }

  &>* {
    width: 700px;
    margin-top: 20px;
    padding: 20px;
    border-radius: 20px;
    background-color: white;
  }

  .orderFormByChannel2-header {
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }

    &:hover {
      color: #666;
    }
  }

  .orderFormByChannel2-footer {
    text-align: right;
  }

  .orderFormByChannel2-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      font-size: 25px;
      font-weight: bold;
    }
  }

  .customersTable {
    .el-table__row .el-table__cell {
      padding: 0;

      .cell {
        height: 60px;
        line-height: 60px;
      }
    }
  }

  .checkItem {
    height: 60px !important;
    margin-bottom: 0 !important;

    .el-form-item__content {
      line-height: 58px;
    }

    .el-form-item__error {
      top: unset;
      bottom: 0 !important;
    }
  }

  .customersItem .el-form-item__content {
    margin-left: 0 !important;
  }

  .customersItem .el-radio__label {
    display: none;
  }

  .time {
    width: 100%;
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 10px;
  }

  .add {
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    border: 1px #dcdfe6 dashed;
  }
}
</style>
